import { createAction } from "redux-actions";

export const QUOTE_LIST = "QUOTE_LIST";
export const quoteList = createAction(QUOTE_LIST);

export const QUOTE_DETAILS = "QUOTE_DETAILS";
export const quoteDetails = createAction(QUOTE_DETAILS);

export const UPDATE_QUOTE = "UPDATE_QUOTE";
export const updateQuote = createAction(UPDATE_QUOTE);

export const DELETE_QUOTE = "DELETE_QUOTE";
export const deleteQuote = createAction(DELETE_QUOTE);

export const RESEND_QUOTE_TO_ZOHO = "RESEND_QUOTE_TO_ZOHO";
export const resendQuoteToZoho = createAction(RESEND_QUOTE_TO_ZOHO);
